// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  TableCell,
  TableRow,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  Table,
  TableBody,
  TableHead,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { TableContainer } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import type { ChangedFloorPlanRow } from '../types';
import messages from '../messages';
import {
  HEADER_MESSAGE_KEYS,
  bodyCellSx,
  floorPlanCellSx,
  headCellSx,
  tableContainerSx,
  tableSx,
  transparentRowSx,
} from '../Step1Table/constants';
import { FloorPlanName, formatCurrencyCell } from '../Step1Table/hooks';

type Step2TableProps = {
  rows: Array<ChangedFloorPlanRow>,
};

const step2FloorPlanCellSx = {
  ...floorPlanCellSx,
  py: 1.5,
};

const step2BodyCellSx = {
  ...bodyCellSx,
  py: 1.5,
};

const step2TableContainerSx = {
  ...tableContainerSx,
  mt: 1,
};

const Step2Table = ({ rows }: Step2TableProps) => {
  return (
    <TableContainer sx={step2TableContainerSx}>
      <Table size="small" sx={tableSx}>
        <TableHead sx={{ backgroundColor: 'transparent' }}>
          <TableRow sx={transparentRowSx}>
            {HEADER_MESSAGE_KEYS.map((messageKey) => (
              <TableCell
                key={messageKey}
                variant="head"
                align="left"
                sx={headCellSx}
              >
                <Typography variant="labelLarge" component="span">
                  <FormattedMessage {...messages[messageKey]} />
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.floorPlanId} sx={transparentRowSx}>
              <TableCell variant="body" align="left" sx={step2FloorPlanCellSx}>
                <FloorPlanName name={row.floorPlanName} />
              </TableCell>
              <TableCell variant="body" align="left" sx={step2BodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {row.bedsBath}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={step2BodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(row.currentGrossRent)}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={step2BodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(row.newGrossRent)}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={step2BodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(row.currentUtilityAllowance)}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={step2BodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(row.newUtilityAllowance)}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Step2Table;
